import React from 'react';

const OpenOrderTitle = ({ record }) => {
	return <span>OpenOrder {record ? `"${record.id}"` : ''}</span>;
};
export default OpenOrderTitle;
